
export const form = {
  orderedLayouts: ['CustomerDatas', 'KnowUs', 'Target', 'null', 'HowManyTimes', 'WhatLevel', 'ChoiceCriteria', 'StarterPack', 'Offers', 'Options', 'FinalCustomerDatas', 'EndStep'],
  currentLayout: 'CustomerDatas',
  authorizedStep: {'CustomerDatas': false, 'KnowUs': false, 'Target': false, 'TargetFitness': false, 'TargetWeightloss': false, 'TargetZen': false, 'TargetBodybuilding': false, 'HowManyTimes': false, 'WhatLevel': false, 'ChoiceCriteria': false, 'StarterPack': false, 'Offers': false, 'Options': false, 'FinalCustomerDatas': false, 'EndStep': false},
  resultJson: {
    'advisor': {},
    'userInfos': {
      'firstname': '',
      'lastname': '',
      'phone': '',
      'email': '',
      'gender': '',
      'sponsorGender': '',
      'sponsorLastname': '',
      'sponsorFirstname': '',
      'surprise': false
    },
    'offer': {
      'name': '',
      'initialPrice': 0,
      'recurrentPrice': 0,
      'commitment': '',
      'options': []
    },
    'target': ''
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/config/form.js
// module id = null
// module chunks = 